import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { RefreshCw, X } from "lucide-react";

export function PwaUpdatePrompt() {
  const [reg, setReg] = useState(null);

  useEffect(() => {
    const onUpdate = (e) => setReg(e.detail);
    window.addEventListener("sw-update-available", onUpdate);
    return () => window.removeEventListener("sw-update-available", onUpdate);
  }, []);

  if (!reg) return null;

  const reload = () => {
    if (reg.waiting) reg.waiting.postMessage({ type: "SKIP_WAITING" });
    else window.location.reload();
  };

  return (
    <div
      className="fixed top-3 left-1/2 -translate-x-1/2 z-[10000] w-[calc(100%-1.5rem)] max-w-md safe-top"
      data-testid="pwa-update-prompt"
    >
      <div className="flex items-center gap-3 bg-[#cc0033] text-white px-4 py-3 shadow-lg border border-black/10">
        <RefreshCw className="w-5 h-5 shrink-0" />
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold leading-tight">Nuova versione disponibile</p>
          <p className="text-xs opacity-80 leading-tight">Aggiorna per usare l'ultima versione.</p>
        </div>
        <Button
          onClick={reload}
          className="rounded-none bg-white text-[#cc0033] hover:bg-white/90 h-8 px-3 text-xs font-bold"
          data-testid="pwa-update-reload-button"
        >
          Aggiorna
        </Button>
        <button
          onClick={() => setReg(null)}
          className="shrink-0 opacity-80 hover:opacity-100"
          aria-label="Chiudi"
          data-testid="pwa-update-dismiss-button"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
